import { Drawer } from '@material-tailwind/react';
import VoucherHistoryPanel, {
  VoucherHistoryPanelProps,
} from './VoucherHistoryPanel';

type VoucherHistoryBottomSheetProps = VoucherHistoryPanelProps & {
  open: boolean;
  onClose: () => void;
};

/**
 * 개편 LMS (교사) - 이용권 관리 페이지 > 이용권 내역 하단 드로어 (모바일용)
 */
const VoucherHistoryBottomSheet = ({
  open,
  classId,
  selectedVoucher,
  onClose,
}: VoucherHistoryBottomSheetProps) => {
  return (
    <Drawer
      placement="bottom"
      open={open}
      onClose={onClose}
      overlay={true}
      size={600}
      className="voucher-history-drawer left-0 right-0 z-[9999] max-h-[85vh] w-full overflow-y-auto rounded-t-2xl px-5 py-2.5"
    >
      <VoucherHistoryPanel
        classId={classId}
        selectedVoucher={selectedVoucher}
      />
    </Drawer>
  );
};

export default VoucherHistoryBottomSheet;
